import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

interface ClientPortalInterface {
  children: React.ReactNode;
  show?: boolean;
  onClose?: () => void;
  selector: string;
}

/**
 * A component that renders its children into a portal at the specified DOM selector
 * @param {Object} props - The component props
 * @param {React.ReactNode} props.children - The content to render in the portal
 * @param {string} props.selector - CSS selector for the DOM element to render the portal into
 * @param {boolean} [props.show=true] - Whether to show the portal
 * @returns {React.ReactPortal | null} The portal element or null if not shown
 */

export const ClientPortal = ({
  children,
  selector,
  show = true,
}: ClientPortalInterface): React.ReactPortal | null => {
  const [selectorElement, setSelectorElement] = useState<Element | null>(null);
  useEffect(() => {
    setSelectorElement(document.querySelector(selector));
  }, [selector]);
  return show && selectorElement
    ? createPortal(children, selectorElement!)
    : null;
};
